import React, {
  useState,
  useEffect,
  useCallback,
  useLayoutEffect,
} from "react";
import { Accordion, Button, Card, Form, Modal, Spinner } from "react-bootstrap";
import { FaChevronCircleUp, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import Message from "./Message";
import {
  getQuestionResponse,
  postResponse,
  getQuestionsOnly,
} from "../../_redux/actions/ActionQuestions";
import {
  getClarificationType,
  getClarificationTemplate,
  getGeneralSettings,
} from "../../_redux/actions/ActionSettings";
import { getTicket } from "../../_redux/actions/ActionTicket";
import { getUserData } from "../../_redux/actions/ActionUser";
import { postQueryResponse } from "../../_redux/actions/ActionFeedback";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { useForm } from "react-hook-form";
import Helpers from "./Helpers/Helpers";
import useComponentVisible from "../../hooks/useComponentVisible";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import swal from "sweetalert";
// import { MentionsInput, Mention } from "react-mentions";
import ClipLoader from "react-spinners/ClipLoader";
import autosize from "../../_helpers/autosize";

const Main = ({
  response,
  getQuestionResponse,
  getTicket,
  postResponse,
  totalResponse,
  getUserData,
  user,
  getClarificationType,
  clarificationType,
  getQuestionsOnly,
  questionsOnly,
  totalOnly,
  settings,
  loading,
  feedback,
  customer,
  postQueryResponse,
  queryId,
  question,
}) => {
  const history = useHistory();
  const [showClarification, setShowClarification] = useState(false);
  const [page, setPage] = useState(1);
  const [entityType, setEntityType] = useState("");
  const [questionCount, setQuestionCount] = useState(0);
  const [sending, setSending] = useState(false);
  const MAX_LENGTH = 120;
  const [query] = useState("");

  // const autoFocus = useCallback((el) => (el ? el.focus() : null), []);

  const {
    ref,
    componentVisible,
    //  setComponentVisible,
    setIgnoreClick,
  } = useComponentVisible(false);

  useEffect(() => {
    getQuestionResponse(customer.id, 1, entityType, query);
    getUserData();
    getClarificationType();
    getQuestionsOnly(customer.id);
  }, [
    getQuestionResponse,
    getUserData,
    getClarificationType,
    getQuestionsOnly,
    customer.id,
    entityType,
    query,
  ]);
  const loadFunc = () => {
    getQuestionResponse(customer.id, page + 1, entityType, query);
    setPage(page + 1);
  };

  useLayoutEffect(() => {
    autosize(document.getElementById("mentions"), {
      container: document.getElementById("scrollableDiv"),
    });
  }, []);

  const { register, handleSubmit, setValue, watch } = useForm({
    mode: "onBlur",
    defaultValues: {},
  });
  const message = watch("response_text", "");
  const onClarify = (data) => {
    if (message.length < settings[0].clarification_limit) {
      toast.error("Character is less than clarification limit");
    } else {
      setIgnoreClick(true);

      swal({
        text: "Are you sure to send this message as clarify?",
        buttons: true,
        icon: "warning",
      })
        .then(async (confirm) => {
          setSending(true);
          if (confirm) {
            await postResponse(
              { ...data, question_id: question.id, send_to: "clarify" },
              user.id,
              history
            );
          }
        })
        .then(() => {
          setIgnoreClick(false);
        })
        .catch((err) => {
          console.log(err);
          setIgnoreClick(false);
          setSending(false);
        });
    }
  };
  const onAstroClarify = (data) => {
    if (message.length < settings[0].clarification_limit) {
      toast.error("Character is less than clarification limit");
    } else {
      setIgnoreClick(true);

      swal({
        text: "Are you sure to send this message as clarify?",
        buttons: true,
        icon: "warning",
      })
        .then(async (confirm) => {
          setSending(true);

          if (confirm) {
            await postResponse(
              { ...data, question_id: question.id, send_to: "moderator" },
              user.id,
              history
            );
          }
        })
        .then(() => {
          setIgnoreClick(false);
        })
        .catch((err) => {
          console.log(err);
          setSending(false);
          setIgnoreClick(false);
        });
    }
  };
  const onAstrologer = (data) => {
    if (message.length < settings[0].moderator_answer_limit) {
      toast.error("Character is less than moderator answer limit");
    } else {
      setIgnoreClick(true);

      swal({
        text: "Are you sure to send this message to astrologer?",
        buttons: true,
        icon: "warning",
      })
        .then(async (confirm) => {
          setSending(true);

          if (confirm) {
            await postResponse(
              { ...data, question_id: question.id, send_to: "astrologer" },
              user.id,
              history
            );
          }
        })
        .then(() => {
          setIgnoreClick(false);
        })
        .catch((err) => {
          console.log(err);
          setSending(false);
          setIgnoreClick(false);
        });
    }
  };
  const onModerator = (data) => {
    if (message.length < settings[0].astrologer_answer_limit) {
      toast.error("Character is less than astrologer answer limit");
    } else {
      setIgnoreClick(true);

      swal({
        text: "Are you sure to send this message to moderator?",
        buttons: true,
        icon: "warning",
      })
        .then(async (confirm) => {
          setSending(true);

          if (confirm) {
            await postResponse(
              { ...data, question_id: question.id, send_to: "moderator" },
              user.id,
              history
            );
          }
        })
        .then(() => {
          setIgnoreClick(false);
        })
        .catch((err) => {
          console.log(err);
          setSending(false);
          setIgnoreClick(false);
        });
    }
  };
  const onAnswer = (data) => {
    if (message.length < settings[0].moderator_answer_limit) {
      toast.error("Character is less than moderator answer limit");
    } else {
      setIgnoreClick(true);

      swal({
        text: "Are you sure to send this message as answer?",
        buttons: true,
        icon: "warning",
      })
        .then(async (confirm) => {
          setSending(true);

          if (confirm) {
            await postResponse(
              { ...data, question_id: question.id, send_to: "answer" },
              user.id,
              history
            );
          }
        })
        .then(() => {
          setIgnoreClick(false);
        })
        .catch((err) => {
          console.log(err);
          setSending(false);
          setIgnoreClick(false);
        });
    }
  };

  const onCancel = (data) => {
    setIgnoreClick(true);

    swal({
      text: "Are you sure to cancel this message?",
      buttons: true,
      icon: "warning",
    })
      .then(async (confirm) => {
        setSending(true);

        if (confirm) {
          await postQueryResponse(
            {
              ...data,
              question_id: feedback && feedback[0].id,
              type: "cancel",
            },
            queryId,
            history
          );
        }
      })
      .then(() => {
        setIgnoreClick(false);
      })
      .catch((err) => {
        console.log(err);
        setSending(false);
        setIgnoreClick(false);
      });
  };

  const onFreeQuestion = (data) => {
    setIgnoreClick(true);

    swal({
      text: "Are you sure to send a free question?",
      buttons: true,
      icon: "warning",
    })
      .then(async (confirm) => {
        setSending(true);

        if (confirm) {
          await postQueryResponse(
            {
              ...data,
              question_id: feedback && feedback[0].id,
              type: "free question",
            },
            queryId,
            history
          );
        }
      })
      .then(() => {
        setIgnoreClick(false);
      })
      .catch((err) => {
        console.log(err);
        setSending(false);
        setIgnoreClick(false);
      });
  };

  const onAstrologerQa = (data) => {
    setIgnoreClick(true);

    swal({
      text: "Are you sure to send this message to astrologer?",
      buttons: true,
      icon: "warning",
    })
      .then(async (confirm) => {
        setSending(true);

        if (confirm) {
          await postQueryResponse(
            {
              ...data,
              question_id: feedback && feedback[0].id,
              type: "to astrologer",
            },
            queryId,
            history
          );
        }
      })
      .then(() => {
        setIgnoreClick(false);
      })
      .catch((err) => {
        console.log(err);
        setSending(false);
        setIgnoreClick(false);
      });
  };

  const onAnswerQa = (data) => {
    setIgnoreClick(true);

    swal({
      text: "Are you sure to send this message?",
      buttons: true,
      icon: "warning",
    })
      .then(async (confirm) => {
        setSending(true);

        if (confirm && feedback) {
          await postQueryResponse(
            { ...data, question_id: feedback && feedback[0].id, type: "send" },
            queryId,
            history
          );
        } else if (confirm && !feedback) {
          console.log("");
        }
      })
      .then(() => {
        setIgnoreClick(false);
      })
      .catch((err) => {
        console.log(err);
        setSending(false);
        setIgnoreClick(false);
      });
  };
  return (
    <div className="main-chat d-flex flex-direction-column position-relative">
      <div className="top-header">
        {questionsOnly && (
          <div className="d-flex align-items-center">
            <div className="scroll-nav mr-3 d-flex flex-column align-items-center">
              {questionCount >= 1 ? (
                <FaChevronUp
                  color="#bc2a20"
                  onClick={() => setQuestionCount(questionCount - 1)}
                  className="pointer"
                />
              ) : (
                <FaChevronUp color="#707070" />
              )}
              <div className="count">{questionCount + 1}</div>
              {questionCount < questionsOnly.length - 1 ? (
                <FaChevronDown
                  color="#bc2a20"
                  onClick={() => setQuestionCount(questionCount + 1)}
                  className="pointer"
                />
              ) : (
                <FaChevronDown color="#707070" />
              )}
            </div>

            <img
              src={
                questionsOnly[questionCount]?.customer?.profile_image
                  ? questionsOnly[questionCount]?.customer?.profile_image
                  : "/assets/images/avatar.png"
              }
              alt=""
              className="user-img"
            />
            <h6 className="pointer">
              {questionsOnly[questionCount]?.question.substring(0, MAX_LENGTH)}
            </h6>
          </div>
        )}
        <p>{questionsOnly[questionCount]?.created.slice(0, 10)}</p>
      </div>

      <div className="roles">
        <Form>
          <Form.Check
            inline
            type="radio"
            label="All"
            name="response"
            onClick={() => {
              setEntityType("");
              setPage(1);
            }}
          />
          <Form.Check
            inline
            type="radio"
            label="System"
            name="response"
            onClick={() => {
              setEntityType("system");
              setPage(1);
            }}
          />
          <Form.Check
            inline
            type="radio"
            label="Questions"
            name="response"
            onClick={() => {
              setEntityType("question");
              setPage(1);
            }}
          />
          <Form.Check
            inline
            type="radio"
            label="Answers"
            name="response"
            onClick={() => {
              setEntityType("answer");
              setPage(1);
            }}
          />
        </Form>
      </div>

      <div className="message-wrapper">
        <div
          className={
            componentVisible
              ? `messages main-conversation-sm`
              : `messages main-conversation`
          }
          id="scrollableDiv"
        >
          <InfiniteScroll
            dataLength={response.length}
            next={loadFunc}
            style={{
              display: "flex",
              flexDirection: "column-reverse",
              overflow: "hidden",
              paddingTop: "10px",
            }}
            inverse={true}
            hasMore={response.length < totalResponse}
            loader={<Spinner animation="border" variant="danger" size="sm" />}
            scrollableTarget="scrollableDiv"
            pullDownToRefreshThreshold={50}
          >
            {response.length > 0 ? (
              response.map((item, index) => (
                <div className="d-flex mb-2">
                  <img
                    src={
                      item.response_from_user.image
                        ? item.response_from_user.image
                        : "/assets/images/avatar.png"
                    }
                    className="message-avatar"
                    alt=""
                  />
                  <Message
                    type={item.response_type}
                    name={item.response_from_user.name}
                    message={item.response_text}
                    pin={item.pinned}
                    created={item.created_at}
                    id={item.id}
                    entity_type={item.entity_type}
                  />
                </div>
              ))
            ) : (
              <Loader />
            )}
          </InfiniteScroll>
        </div>
      </div>

      <div
        className="d-flex pl-3"
        style={{ position: "absolute", bottom: "0", width: "100%" }}
        ref={ref}
      >
        {/* {componentVisible ? null : (
          <div className="message-input">
            <Form.Control
              type="text"
              placeholder="Enter message here"
              {...register("response_text")}
              onClick={() =>
                !componentVisible
                  ? setComponentVisible(true)
                  : setComponentVisible(false)
              }
              disabled={sending}
              ref={autoFocus}
            />
          </div>
        )} */}
        {/* {componentVisible && ( */}
        <div className="message-input-lg ">
          <Form>
            <textarea
              className="mentions"
              placeholder="Enter message here"
              {...register("response_text")}
              onChange={({ target: { value } }) => {
                setValue("response_text", value);
              }}
              value={message}
              autoFocus
              id="mentions"
            />

            {user.user.role !== "superuser" && (
              <div
                className={
                  message?.length < settings[0].moderator_answer_limit
                    ? `char-count text-danger`
                    : `char-count text-success`
                }
              >
                <ClipLoader
                  loading={sending}
                  size={16}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                  className="mx-2"
                />
                {message?.length}
              </div>
            )}

            <div className="btn-collect">
              <div className="d-flex align-items-center">
                <div
                  className="clarify-icon mr-2"
                  onClick={() => {
                    setShowClarification(true);
                    setIgnoreClick(true);
                  }}
                  data-tip="Clarification helpers"
                >
                  {/* <ReactTooltip place="left" type="dark" effect="float" /> */}
                  <FaChevronCircleUp
                    size="24"
                    color="#BC2A20"
                    className="pointer"
                  />
                </div>
                <Helpers
                  setMessage={setValue}
                  setIgnoreClick={setIgnoreClick}
                />
              </div>
              <div>
                {user.user.role === "astrologer" && (
                  <>
                    <Button
                      className="btn-clarify"
                      onClick={handleSubmit(onAstroClarify)}
                      disabled={sending}
                    >
                      Clarify
                    </Button>
                    <Button
                      className="btn-astrologer"
                      onClick={handleSubmit(onModerator)}
                      disabled={sending}
                    >
                      Moderator
                    </Button>
                  </>
                )}
                {user.user.role === "moderator" && (
                  <>
                    <Button
                      className="btn-clarify"
                      onClick={handleSubmit(onClarify)}
                      disabled={sending}
                    >
                      Clarify
                    </Button>
                    <Button
                      className="btn-astrologer"
                      onClick={handleSubmit(onAstrologer)}
                      disabled={sending}
                    >
                      Astrologer
                    </Button>
                    <Button
                      className="btn-answer"
                      onClick={handleSubmit(onAnswer)}
                      disabled={sending}
                    >
                      Answer
                    </Button>
                  </>
                )}
                {(user.user.role === "qa" ||
                  user.user.role === "superuser") && (
                  <>
                    <Button
                      className="btn-cancel"
                      onClick={handleSubmit(onCancel)}
                      disabled={sending}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn-clarify"
                      onClick={handleSubmit(onFreeQuestion)}
                      disabled={sending}
                    >
                      Free Question
                    </Button>
                    <Button
                      className="btn-astrologer"
                      onClick={handleSubmit(onAstrologerQa)}
                      disabled={sending}
                    >
                      Create New Question
                    </Button>

                    <Button
                      className="btn-answer"
                      onClick={handleSubmit(onAnswerQa)}
                      disabled={sending}
                    >
                      Send
                    </Button>
                  </>
                )}
              </div>
            </div>
          </Form>
        </div>
        {/* )} */}
      </div>
      <Modal
        show={showClarification}
        onHide={() => {
          setShowClarification(false);
          setIgnoreClick(false);
        }}
        className="modal-left"
      >
        <Modal.Header closeButton>
          <Modal.Title>Clarification Templates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Accordion defaultActiveKey="0">
            {clarificationType.length > 0 &&
              clarificationType.map((item) => (
                <Card>
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey={item.clarification_type}
                    className="pointer d-flex align-items-center justify-content-between"
                  >
                    <span>{item.clarification_type}</span>
                    <FaChevronDown />
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={item.clarification_type}>
                    <Card.Body>
                      {item.clarifytemplate_set.map((clarify) => (
                        <li
                          className="clarify-list"
                          onClick={() => {
                            setValue("response_text", clarify.clarification);
                            setShowClarification(false);
                            setIgnoreClick(false);
                          }}
                        >
                          {clarify.clarification}
                        </li>
                      ))}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
          </Accordion>
        </Modal.Body>
      </Modal>
    </div>
  );
};
const mapStateToPros = (state) => ({
  response: state.customerQuestions.questionResponse,
  questionsOnly: state.customerQuestions.questionsOnly,
  totalOnly: state.customerQuestions.totalOnly,
  totalResponse: state.customerQuestions.totalResponse,
  question: state.ticket.ticket,
  feedback: state.feedback.singleFeedback,
  user: state.user.user,
  clarificationType: state.clarificationType.clarificationType,
  settings: state.GeneralSettings.settings,
  loading: state.ui.loading,
});

export default connect(mapStateToPros, {
  getTicket,
  getQuestionResponse,
  postResponse,
  getUserData,
  getClarificationType,
  getClarificationTemplate,
  getQuestionsOnly,
  getGeneralSettings,
  postQueryResponse,
})(Main);
